/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AbstractFormComponent,
  BuilderNavigationService,
  BuilderUserContext,
  CommonActions,
  FormActionPipelines,
  FormFlowState,
} from '@gh/builder-shared';
import {
  AelEvents,
  CloneUsingPriceBookType,
  PRIVILEGED_EP_SYS_VARS_SALES,
} from '@gh/builder-shared-data';
import {
  ActionFlow,
  EnumDictionary,
  getRouteInitData,
  resetPrivilegedTokensAndUpdate,
  updatePrivilegedControls,
} from '@gh/common-shared';
import { ID, OfficeData } from '@gh/common-shared-data';
import { DialogService, yesAnswer, yesNoConfirmation } from '@gh/core-ui';
import { filter$ } from '@gh/rx/operators';
import { assign } from 'lodash';
import { SystemVarsSales } from '../../resources/model/system-vars-sales.model';
import { SystemVarsSalesBusinessService } from '../../resources/system-vars-sales-business.service';
import { SystemVarsSalesFormState } from './system-vars-sales-tab.form.service';

@Component({
  standalone: false,
  selector: 'gh-system-vars-sales-tab',
  templateUrl: 'system-vars-sales-tab.component.html',
  styleUrls: ['system-vars-sales-tab.component.scss'],
  viewProviders: [SystemVarsSalesFormState],
})
export class SystemVarsSalesTabComponent extends AbstractFormComponent<SystemVarsSales> implements OnInit {

  cloneUsingPriceBookTypes: EnumDictionary<CloneUsingPriceBookType>;
  websiteLeads = [];

  private sysVarsSales: SystemVarsSales;

  constructor(private pipelines: FormActionPipelines,
              private businessService: SystemVarsSalesBusinessService,
              private actions: CommonActions,
              public form: SystemVarsSalesFormState,
              private route: ActivatedRoute,
              private dialogService: DialogService,
              private navigationService: BuilderNavigationService,
              private userContext: BuilderUserContext) {
    super();
  }

  get completeFlow(): ActionFlow<FormFlowState<SystemVarsSales>> {
    return this.pipelines.complete({
      execute: this.actions.execute((state: FormFlowState<SystemVarsSales>) =>
        this.businessService.update(state.form.submitValue, this.websiteLeads)),
      finish: (state: FormFlowState<any>) => {
        const { value } = state;
        this.sysVarsSales = value.sysVarsSales;
        this.form.build(value.sysVarsSales);
        this.websiteLeads = value.websiteLeads.assignees;
      },
    });
  }

  ngOnInit(): void {
    const { sysVarsSales, websiteLeads } = getRouteInitData(this.route);
    assign(this, getRouteInitData(this.route));
    this.websiteLeads = websiteLeads.assignees;

    this.form.build(sysVarsSales);
  }

  onPrivilegedTokenReceivedSales(): void {
    updatePrivilegedControls(this.form, PRIVILEGED_EP_SYS_VARS_SALES);
  }

  onAssignLead(lead: any): void {
// @ts-expect-error Legacy typing suppression
    const index = this.websiteLeads.findIndex((el) => lead.salespersonId === el.salespersonId);
    if (index >= 0) {
// @ts-expect-error Legacy typing suppression
      this.websiteLeads[index].isAssigned = !lead.isAssigned;
    }
    this.form.group.markAsDirty();
  }

  onReset(): void {
    this.dialogService
      .confirmation(yesNoConfirmation('msg_reset')).pipe(
      filter$(yesAnswer))
      .subscribe(() => {
        resetPrivilegedTokensAndUpdate(this.form);
        this.form.build(this.sysVarsSales);
      });
  }

  goToAel(entityId?: ID, entityType?: string, label?: string): void {
    const office = <OfficeData>this.userContext.office;

    this.navigationService.goToAel({
      entityId: entityId ? entityId : office.id,
      entityType: entityType ? entityType : 'OFFICE',
      eventTypeIds: [AelEvents.Office.EditedSales],
      label: label ? label : 'lbl_menu_sales',
    });
  }
}
